import type { BrandConfig } from "@ui-d2c/types";

export function getServerConfig(): {
  brand: BrandConfig;
} {
  return {
    brand: {
      value: process.env.BRAND || "scott",
      isScott: process.env.BRAND === "scott",
      isDolomite: process.env.BRAND === "dolomite",
      isSyncros: process.env.BRAND === "syncros",
      isBergamont: process.env.BRAND === "bergamont",
    },
  };
}
